import { useEffect } from "react";
import LazyLoad from "vanilla-lazyload";

declare global {
  interface Window {
    lazyLoadInstance: any;
  }
}

type LazyIframeProps = {
  src: string;
  title: string;
  className?: string;
  frameBorder?: string;
  scrolling?: string;
  style: {};
};

export const LazyIframe = ({
  src,
  title,
  className,
  ...props
}: LazyIframeProps) => {
  useEffect(() => {
    if (typeof window === "undefined") return;
    // Ensure it is initialised only one time
    if (!window.lazyLoadInstance) {
      window.lazyLoadInstance = new LazyLoad();
    }
    window.lazyLoadInstance.update();
  }, []);

  return (
    <iframe
      title={title}
      className={`${className} lazy`}
      data-src={src}
      {...props}
    />
  );
};
